// Controller for auctions
(function () {
    SUGApp.controller("auctionsController", ["$scope",
      function ($scope,) {
        $scope.auctionsurl = ( typeof window.globalcfg?.solutions?.auctions?.secureurl != 'undefined' ) ? window.globalcfg?.solutions?.auctions?.secureurl : 'https://auctions.signupgenius.com';
        $scope.auctionsfullname = ( typeof window.globalcfg?.solutions?.auctions?.fullname != 'undefined' ) ? window.globalcfg?.solutions?.auctions?.fullname : 'SignUpGenius Auctions';
        $scope.auctionsshortname = ( typeof window.globalcfg?.solutions?.auctions?.shortname != 'undefined' ) ? window.globalcfg?.solutions?.auctions?.shortname : 'Auctions';
      }
    ]);
  })();